<div page_loading *ngIf="loading"></div>
<ng-template [ngIf]="forbidden">
	<app-forbidden></app-forbidden>
</ng-template>
<ng-template [ngIf]="!forbidden">
	<ng-template [ngIf]="authMode === 'oauth2'">
		<div *ngIf="isOauthLogged">
			<div class="container">
				<header main_header *ngIf="!isRouteScAnaliticaSintetica && !isTabletSizeScreen; else responsiveHeader"></header>
				<ng-template #responsiveHeader>
					<div *ngIf="!isRouteScAnaliticaSintetica" [menuSezioni]="menuSezioni" main_responsive_header></div>
				</ng-template>
				<hr class="hidden">
				<div id="content-container" #content>
					<nav aria-label="navigazione" ctxMenu="" #ctxMenu *ngIf="!isTabletSizeScreen" [menuSezioni]="menuSezioni"></nav>
					<div aria-live="polite" class="sr-only" [innerText]="currentTitle"></div>
					<router-outlet></router-outlet>
					<div notify-service [attr.id]="'notifyService'"></div>
					<div confirm-modal [attr.id]="'modaleDiConferma'"></div>
				</div>
				<hr class="hidden">
			</div>
			<app-footer *ngIf="show"></app-footer>
			<modale-ricerca *ngIf="show"></modale-ricerca>
		</div>
	</ng-template>
	<ng-template [ngIf]="authMode === 'ldap'">
		<div class="container">
			<header main_header *ngIf="!isRouteScAnaliticaSintetica && !isTabletSizeScreen && isLogin === false; else responsiveHeader"></header>
			<ng-template #responsiveHeader>
				<div *ngIf="!isRouteScAnaliticaSintetica && isLogin === false" [menuSezioni]="menuSezioni" main_responsive_header></div>
			</ng-template>
			<hr class="hidden">
			<div id="content-container" #content>
				<nav aria-label="navigazione" ctxMenu="" #ctxMenu *ngIf="!isTabletSizeScreen && isLogin === false" [menuSezioni]="menuSezioni"></nav>
				<div aria-live="polite" class="sr-only" [innerText]="currentTitle"></div>
				<router-outlet></router-outlet>
				<div notify-service [attr.id]="'notifyService'"></div>
				<div confirm-modal [attr.id]="'modaleDiConferma'"></div>
			</div>
			<hr class="hidden">
		</div>
		<app-footer *ngIf="show"></app-footer>
		<modale-ricerca *ngIf="show"></modale-ricerca>
	</ng-template>
</ng-template>
<app-spinner></app-spinner>